<div class="segmented-control">
    <button
        type="button"
        class="segment"
        *ngFor="let label of labels; trackBy: trackByLabel"
        [class.selected]="isSelected(label)"
        (click)="onSegmentClick(label)"
        [attr.aria-pressed]="isSelected(label)"
        [attr.data-test]="getTestAttribute(label)"
    >
        {{ label }}
    </button>
</div>
